import {checkIfBotPlayer} from "../players/checkIfBotPlayer";

/**
 * Есть ли среди противников в бою бот (см. checkIfBotPlayer). Тогда подкрутка
 * костей уровнем бонуса снимается с бросающего: кость урона «всегда 0»
 * божественного бота — только против живых игроков и нейтральных отрядов,
 * против любых ботов он бросает обычные кости (решение владельца). Отряд в
 * ближнем бою может быть зажат сразу несколькими противниками, а кости у него
 * на бой одни — хватает одного бота среди них.
 *
 * Сам бросающий в счет не идет: при выстреле по отряду на собственном
 * квартале стрелка он попадает в список владельцев целей.
 *
 * Нейтральных отрядов в списке противников нет (их владельца нет в списке
 * игроков) — против них подкрутка остается, как против живого игрока. ИИ-игрок
 * ботом не считается.
 *
 * Только для ближнего боя и стрельбы: разведке рудника противник не нужен, и
 * подкрутка там действует всегда.
 *
 * Правило видно по костям: обычные кости божественного бота против
 * участника выдали бы в нем бота. Сейчас с божественным ботом в рейтинговой
 * партии с живыми игроками встречаются только явные боты (подмена неявных
 * ботов на явные у рубиновой и божественной лиги — 100%, см.
 * configs/visibleRankedBots).
 *
 * @param {Object} [rollingPlayer] - владелец бросающего отряда
 * @param {Object|Object[]} [opponents] - игрок-цель или все игроки на другой
 *   стороне боя; пусто — бросок не в бою
 * @returns {boolean}
 */
export const checkIfAnyOpponentIsBot = (rollingPlayer, opponents) => {
  if (!opponents) {
    return false;
  }
  const opponentList = Array.isArray(opponents) ? opponents : [opponents];
  return opponentList.some((opponent) => (
    Boolean(opponent)
    && (!rollingPlayer || opponent.id !== rollingPlayer.id)
    && checkIfBotPlayer(opponent)
  ));
};
